// @flow

export const CLEAR_RESOURCES = 'resources/CLEAR'
